import Sobre from "../components/Sobre";
import AoVivo from "../components/AoVivo";

export default function SobrePage() {
  return (
    <div data-testid="page-sobre" className="pt-24 sm:pt-32">
      <Sobre />
      <AoVivo />
    </div>
  );
}
